module.exports = __webpack_public_path__ + "img/empty-chat.541ab120.png";